import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function GetSupplierChangesDates(params) {
  const res = await api.get(routes.GET_SUPPLIER_CHANGES_DATES, {
    params: params,
  });

  return res;
}
